<script>
const plate_num = '';
const start_time = '';
const end_time = ''
export default {
    plate_num,
    start_time,
    end_time
};
</script>